export default __webpack_public_path__ + "static/media/Connector_Chademo.dc4a7259.svg";